























































import { DynamicDocumentItem, DynamicDocumentItemData, InstallationModuleData } from "@/types";
import Vue, { PropType } from "vue";
import { isItemRequired, imageUrlsForItem } from "@/utilities";

export default Vue.extend({
  props: {
    item: {
      type: Object as PropType<DynamicDocumentItem>,
      required: true
    },

    data: {
      type: Object as PropType<DynamicDocumentItemData>,
      required: true
    },
    documentData: Array as PropType<DynamicDocumentItemData[]>,
    moduleData: Object as PropType<InstallationModuleData>
  },

  computed: {
    isRequired(): boolean {
      return isItemRequired(this.item, this.documentData ?? [this.data], this.moduleData);
    },

    // A photo on this question that the server doesn't have and can't be
    // re-uploaded from this device — the thing that silently blocks Afronden.
    missingOnServer(): boolean {
      return imageUrlsForItem(this.item, this.data).some(url =>
        this.$store.getters["library/missingOnServer"](url)
      );
    },

    icon(): string {
      switch (this.item.type) {
        case "IMAGE":
          return "fa-image";
        case "TEXT":
          return "far fa-comment";
        case "SIGNATURE":
          return "fa-signature";
        case "HIGH-LOW":
          return "mdi-plus-minus-box";
        case "CUSTOM":
          switch (this.item.field) {
            case "layoutPlan":
              return "mdi-grid";
            default:
              return "fa-question-mark";
          }
        default:
          return "fa-question-mark";
      }
    }
  }
});
